import { createFileRoute } from "@tanstack/react-router";
import { Roles } from "@/routes/help/roles";

export const Route = createFileRoute("/dashboard/help/roles")({
	component: Roles,
});
